import { createSlice } from '@reduxjs/toolkit';

const landingSlice = createSlice({
  name: 'landing',
  initialState: {
    useMTService: false,
    useDVService: false,
  },
  reducers: {
    callMTService: () => {},
    callMTServiceSuccess: (state, { payload }) => {
      state.useMTService = payload;
    },
    callDVService: () => {},
    callDVServiceSuccess: (state, { payload }) => {
      state.useDVService = payload;
    },
  },
});

export const { callMTService, callMTServiceSuccess, callDVService, callDVServiceSuccess } = landingSlice.actions;
export default landingSlice.reducer;
